var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.95203 12.2137H1.72328C1.17928 12.2137 0.738281 11.7727 0.738281 11.2287V1.77894C0.738281 1.23494 1.17928 0.793945 1.72328 0.793945H3.95203C4.49603 0.793945 4.93703 1.23494 4.93703 1.77894V11.2287C4.93703 11.7727 4.49603 12.2137 3.95203 12.2137Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0282 12.2049H8.79945C8.25545 12.2049 7.81445 11.7639 7.81445 11.2199V1.77016C7.81445 1.22616 8.25545 0.785156 8.79945 0.785156H11.0282C11.5722 0.785156 12.0132 1.22616 12.0132 1.77016V11.2199C12.0132 11.7639 11.5722 12.2049 11.0282 12.2049Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12298 0.811523C4.31523 0.991273 4.43723 1.24527 4.43723 1.52927V10.979C4.43723 11.523 3.99623 11.964 3.45223 11.964H1.22348C1.16498 11.964 1.10848 11.9565 1.05273 11.9468C1.22873 12.1113 1.46348 12.214 1.72348 12.214H3.95223C4.49623 12.214 4.93723 11.773 4.93723 11.229V1.77927C4.93723 1.29377 4.58523 0.892773 4.12298 0.811523Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1992 0.802734C11.3914 0.982484 11.5134 1.23648 11.5134 1.52048V10.9702C11.5134 11.5142 11.0724 11.9552 10.5284 11.9552H8.29966C8.24116 11.9552 8.18466 11.9477 8.12891 11.938C8.30491 12.1025 8.53966 12.2052 8.79966 12.2052H11.0284C11.5724 12.2052 12.0134 11.7642 12.0134 11.2202V1.77048C12.0134 1.28498 11.6614 0.883734 11.1992 0.802734Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.95203 12.2137H1.72328C1.17928 12.2137 0.738281 11.7727 0.738281 11.2287V1.77894C0.738281 1.23494 1.17928 0.793945 1.72328 0.793945H3.95203C4.49603 0.793945 4.93703 1.23494 4.93703 1.77894V11.2287C4.93703 11.7727 4.49603 12.2137 3.95203 12.2137Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0282 12.2049H8.79945C8.25545 12.2049 7.81445 11.7639 7.81445 11.2199V1.77016C7.81445 1.22616 8.25545 0.785156 8.79945 0.785156H11.0282C11.5722 0.785156 12.0132 1.22616 12.0132 1.77016V11.2199C12.0132 11.7639 11.5722 12.2049 11.0282 12.2049Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.a9f0f14e3a54b2c22fc646425b3428a2.svg";
export { ForwardRef as ReactComponent };